import { Box, Typography } from '@mui/material'
import { Stats } from 'store/companySearch/types'

type Props = { stats: Stats | undefined }
export default function ErrorComponent({ stats }: Props) {
  return (
    <>
      <Box>
        <Typography color="error" mt={2}>
          Something went wrong
        </Typography>
      </Box>
      {stats && ['NO_WINNING_PATENTS', 'COMPANY_HAS_NO_PATENTS'].includes(stats.errorStatus) && (
        <Box sx={{ whiteSpace: 'pre-line' }} whiteSpace={'pre-line'}>
          <Typography fontWeight={'900'} mt={3}>
            No qualifying patents were found for this company’s portfolio
          </Typography>
          {`
          We were unable to include any patents from this company in the analysis, as none met the required quality and data standards. 
          
          This can occur for several reasons: 

          – The patents are too early-stage and lack clear technical claims
          – The patents were filed before the year 2000
          – The patent documents are incomplete or missing crucial sections 
          – The company may have withdrawn or abandoned the filings 
          – The patents are registered under a different legal name (e.g. parent company, university, or individual)
          – The company may have been acquired and filings moved to the acquirer 
          – The IP strategy may focus on trade secrets rather than patents 
          – The filings don’t meet our threshold for clarity, jurisdictional coverage, or comparability 
          – Metadata inconsistencies or alias mismatches may have prevented linking 
          
          If you believe this is incorrect or you are aware of patents that should qualify, please contact us at support@eluteintelligence.com and we can review the data linkage or investigate exceptions.
        `}
        </Box>
      )}
    </>
  )
}
